/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Draf_TInputs */

const en_tut_draf_t = /** @type {(inputs: Tut_Draf_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An AI draft from the meeting transcript`)
};

const id_tut_draf_t = /** @type {(inputs: Tut_Draf_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf AI dari transkrip rapat`)
};

/**
* | output |
* | --- |
* | "An AI draft from the meeting transcript" |
*
* @param {Tut_Draf_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_draf_t = /** @type {((inputs?: Tut_Draf_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Draf_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_draf_t(inputs)
	return en_tut_draf_t(inputs)
});